export default "__VITE_ASSET__05f917ab__"